// The Main Site Object
window.Site = {

    mobileMenuButton    : document.querySelector('.header-mobile-menu-button'),
    mobileMenuContainer : document.querySelector('.mobile-nav-container'),

    bioPicture : document.querySelector('.bio-picture'),

    footer : document.querySelector('.footer'),
    spacer : document.getElementById('spacer'),
    
    bannerContainer : document.querySelector('#news'),
    banner          : document.querySelector('.news-container'),

    // Content To make the press section work
    pressMenuButton : document.querySelector('.header-nav-link[value="press"]'),
    pressContainer  : document.getElementById('press'),

    // Gallery Container
    galleryContainer   : document.querySelector('#gallery'),
    gallerySlider      : document.querySelector('.gallery-slider-container'),
    galleryActiveSlide : null,
    galleryImages      : document.querySelectorAll('.gallery-slide-item-image,.gallery-grid-item-image'),

    // The Main title also acts as a reset item
    siteTitle : document.querySelector('.header-title'),

    // Init Function
    liftoff : () => {

        // There are a few things we need to do on page load
        window.addEventListener('load' , () => {
            Site.setBioPictureTopValue();
            Site.setBannerTopValue();
            Site.setPressColumnWidth();
        });

        // There are a few things we need to on on window resize
        window.addEventListener('resize' , () => {
            Site.setBioPictureTopValue();
            Site.setBannerTopValue();
            Site.setPressColumnWidth();
        });

        //Site.initFlickity()
        Site.initGalleryScroll()
        Site.displayCaptionOnTap()
        Site.resetSiteState()


    },

    // Toggle the class on the body that controls the visibility of the mobile menu
    toggleMobileNavigation : () => {
        document.body.classList.toggle('mobile-menu-is-open');
    },

    // Hide the menu Banner on click
    removeNewsContainer : () => {
        Site.bannerContainer.remove()
        document.documentElement.classList.remove('has-popup')
    },

    // We need to set the value of TOP for the bio picture
    setBioPictureTopValue : () => {

        // If we don't have an image we can abort the operation
        if (!Site.bioPicture) return;

        // Grab the height of the image and the value of the padding
        let imageHeight   = Site.bioPicture.clientHeight;
        let windowHeight  = window.innerHeight;
        let spacerHeight  = Site.spacer.clientHeight * 3;

        // Set the top value
        Site.bioPicture.style.top = `${windowHeight - imageHeight - spacerHeight}px`;

    },

    // Set news banner top value
    setBannerTopValue : () => {

        // If we don't have a news we can silently quit
        if (!Site.banner) return;

        // Grab the height of the image and the value of the padding
        let bannerHeight  = Site.banner.clientHeight;
        let windowHeight  = window.innerHeight;
        let spacerHeight  = Site.spacer.clientHeight * 3;

        // Set the top value
        Site.banner.style.top = `${windowHeight - bannerHeight - spacerHeight}px`;

    },

    // Toggle the body class based on what's been clicked
    toggleBodyClass : (toggledClass) => {
        document.body.classList.toggle(toggledClass)
        Site.setBioPictureTopValue()
    },

    // Close Overlays
    closeOverlay : () => {
        document.body.classList.remove('bio-is-open' , 'advisory-is-open' , 'press-is-open');
    },

    // Set the width of the press column
    setPressColumnWidth : () => {

        if (!Site.pressContainer) return;

        // Grab the distance to the left
        let distanceToLeft = window.innerWidth - Site.pressMenuButton.getBoundingClientRect().left;
        Site.pressContainer.style.setProperty("--column-width", `calc(1rlh + ${distanceToLeft}px)`);

    },

    // Set the gallery style
    setGalleryStyle : (value) => {

        // Set the style of the gallery
        Site.galleryContainer.setAttribute('data-style' , value)

    },

    // On click, scroll down to the gallery, activate slider view, and scroll to the correct slide
    moveSlideIntoView : (slideIndex) => {

        // Eventually close the overlays if they're open
        Site.closeOverlay();

        // Set the gallery to the proper mode
        Site.setGalleryStyle('slider');

        // Scroll into view
        document.getElementById('gallery').scrollIntoView({'behavior' : 'smooth'});
        document.querySelector(`.gallery-slide:nth-child(${slideIndex+1})`).scrollIntoView({'inline' : 'start'});

    },

    // Initialise the new scrollable gallery
    initGalleryScroll : () => {
        if (document.body.classList.contains('home')) return;

        Site.ScrollB = new ScrollBooster({
            viewport                  : document.querySelector('#gallery-slider'),
            content                   : document.querySelector('.gallery-slider-container'),
            scrollMode                : 'native',
            emulateScroll             : true,
            direction                 : 'horizontal',
            bounce                    : false,
            lockScrollOnDragDirection : 'horizontal',  
        });

    },

    // Display captions on mobile tap
    displayCaptionOnTap : () => {
        Site.galleryImages.forEach(image => {
            image.addEventListener('click' , () => {

                // We have tapped a second time on the same image
                if (Site.galleryActiveSlide && Site.galleryActiveSlide == image.parentElement) {
                    Site.galleryActiveSlide.classList.remove('caption-overlay-is-visible')
                    Site.galleryActiveSlide = null;
                    return;
                }

                // We have tapped on a different image and there's a slide active
                if (Site.galleryActiveSlide && Site.galleryActiveSlide != image.parentElement)
                    Site.galleryActiveSlide.classList.remove('caption-overlay-is-visible')

                // Store the new active item
                Site.galleryActiveSlide = image.parentElement;
                Site.galleryActiveSlide.classList.add('caption-overlay-is-visible')

            })
        })
    },

    // When the title is clicked we need to reset the whole site
    resetSiteState : () => {
        Site.siteTitle.addEventListener('click' , () => {

            // Scroll the site back to the top
            window.scrollTo({'top' : 0, 'behavior' : 'smooth'})

            // Close the overlay
            Site.closeOverlay()
            
            // Close the mobile menu
            document.body.classList.remove('mobile-menu-is-open');

            // Close the banner
            Site.removeNewsContainer()


        })
    }

}

// Launch The Script
Site.liftoff()